import { AvailabilityEnum } from '../../../../../../products/ProductTypes';
import {
  ComputeQuantityForGridItemBasedOnPacksParams,
  GetGridBasedOnPacksParams,
  GridItemPossibles,
} from './getGridBasedOnPacks.types';

const computeQuantityForGridItemBasedOnPacks = <T extends GridItemPossibles>({
  gridItem,
  respectStock,
  availability,
  packsWithMultiplier,
}: ComputeQuantityForGridItemBasedOnPacksParams<T>): number => {
  const quantityBasedOnPacks = packsWithMultiplier.reduce((sum, { multiplier, pack }) => {
    const packItem = pack.quantitiesBySize.find((q) => q.sizeId === gridItem.size.id);

    const packItemQuantity = packItem?.quantity || 0;

    return sum + packItemQuantity * multiplier;
  }, 0);

  if (respectStock && availability !== AvailabilityEnum.INFINITE_PRE_ORDER) {
    const stockToAvailability =
      AvailabilityEnum.READY_FOR_DELIVERY === availability ? gridItem.stock : gridItem.futureStock;

    const stockAvailable = stockToAvailability?.availableAmount || 0;

    return Math.min(stockAvailable, quantityBasedOnPacks);
  }

  return quantityBasedOnPacks;
};

export const getGridBasedOnPacks = <T extends GridItemPossibles>({
  grid,
  availability,
  respectStock,
  packsWithMultiplier,
}: GetGridBasedOnPacksParams<T>) => {
  return grid.map((gridItem) => {
    const totalQuantity = computeQuantityForGridItemBasedOnPacks({
      gridItem,
      respectStock,
      packsWithMultiplier,
      availability: availability,
    });

    return { ...gridItem, quantity: totalQuantity };
  });
};
